import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { DatabaseScheduleTarget } from 'libs/end-to-end/src/types/databases/scheduling/database-schedule';
import { DatabaseScheduleTargetType } from 'libs/end-to-end/src/types/databases/scheduling/database-schedule';
import { Setter } from 'libs/end-to-end/src/ui-types';
import React from "react";
import { useMemo } from "react";
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { DataSetSelector } from 'apps/sigma2-ui/src/data-wizard/components/DataSetSelector';
import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

export const DatabaseScheduleTargetSelector = ({
  currentTarget,
  setCurrentTarget,
  dataSets,
}: {
  currentTarget: DatabaseScheduleTarget;
  setCurrentTarget: Setter<DatabaseScheduleTarget>;
  dataSets: DataSet[];
}) => {
    const dropdownValues = useMemo(() => {
        return Object.values(DatabaseScheduleTargetType.Values).map((target) => ({
            optionLabel: target,
            optionValue: target,
        }));
    }, []);
    return <Spacing size="small" direction="vertical">
        <S2Typography variant={'headline-7-alt'} translatedContent={'Target'} />
        <SelectBoxWithSearch
            type="single"
            label={'Target Type'}
            list={dropdownValues}
            selected={currentTarget.type}
            setSelected={(value) => {
                if (value === 'dataset') {
                    setCurrentTarget({
                        type: 'dataset',
                        dataSetId: '',
                    });
                } else if (value === 'transform') {
                    setCurrentTarget({
                        type: 'transform',
                    });
                } else {
                    throw guardExhaustive(value);
                }
            }}
        />
        {currentTarget.type === 'dataset' && (
            <DataSetSelector label={'Dataset'} dataSets={dataSets} dataSetId={currentTarget.dataSetId} setDataSetId={(id) => {
                if (id) {
                    setCurrentTarget({ ...currentTarget, dataSetId: id });
                }
            }} />
        )}
    </Spacing>
}
